import React from 'react';
import AggregateDetail from '@components/aggregateDetail/AggregateDetail';

const Aggregate = () => {
	return (
		<div id="aggregate" className="megaContent">
			<div className="container-fluid">
				<AggregateDetail />
			</div>
		</div>
	);
};

export default Aggregate;
